(function () {

  /**
   * @type {string}
   */

  let code = '';
  /**
   * @type {string[][]}
   */
  const numbers = [
      ['   ###   ','   #   ','  #####  ','  #####  ',' #       ',' ####### ','  #####  ',' ####### ','  #####  ','  #####  '],
      ['  #   #  ','  ##   ',' #     # ',' #     # ',' #    #  ',' #       ',' #     # ',' #    #  ',' #     # ',' #     # '],
      [' #     # ',' # #   ','       # ','       # ',' #    #  ',' #       ',' #       ','     #   ',' #     # ',' #     # '],
      [' #     # ','   #   ','  #####  ','  #####  ',' #    #  ',' ######  ',' ######  ','    #    ','  #####  ','  ###### '],
      [' #     # ','   #   ',' #       ','       # ',' ####### ','       # ',' #     # ','   #     ',' #     # ','       # '],
      ['  #   #  ','   #   ',' #       ',' #     # ','      #  ',' #     # ',' #     # ','   #     ',' #     # ',' #     # '],
      ['   ###   ',' ##### ',' ####### ','  #####  ','      #  ','  #####  ','  #####  ','   #     ','  #####  ','  #####  '],
  ];

  const generateCaptcha = () =>  {

    for (let i = 0; i < 4; i++) {
        const randomNumber = Math.floor(Math.random() * numbers.length);
        code = code + randomNumber;
    }

    let digits = '';
    for (let i = 0; i < 7; i++) {
      for (let char = 0; char < 4; char++) {
          digits = digits + numbers[i][code[char]];
      }
      digits = digits + "\n";
    }

    return digits;
  }

  const showPopup = (element) => {
      if (null != element) {
          element.style.visibility = 'visible';
          element.style.opacity = 1;
      }
  }

  const hidePopup = (element) => {
    if (null != element) {
        element.style.visibility = 'hidden';
        element.style.opacity = 0;
    }
  }

  const onSubmitHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const formContact = document.querySelector('#ContactForm');
        const inputCode = document.querySelector('#ContactForm-captcha');
        const popup1 = document.querySelector('#popup1');
        const miniPopupClose = document.querySelector('#popup1 a.close');
        const miniPopupButtonClose = document.querySelector('#popup1 div.button-ok button');

        if (null != inputCode) {
            const clientCode = inputCode.value.trim();
            if (clientCode !== code) {
                showPopup(popup1);

                popup1.parentElement.addEventListener('keyup', (event) => {
                    if (event.code.toUpperCase() === "ESCAPE") {
                        hidePopup(popup1);
                    }
                });

                if (null != popup1) {
                    popup1.addEventListener('click', (event) => {
                        event.preventDefault();
                        hidePopup(popup1);
                    });
                }

                if (null != miniPopupClose) {
                    miniPopupClose.addEventListener('click', (event) => {
                        event.preventDefault();
                        hidePopup(popup1);
                    });
                }

                if (null != miniPopupButtonClose) {
                    miniPopupButtonClose.addEventListener('click', (event) => {
                        event.preventDefault();
                        hidePopup(popup1);
                    });
                }
            } else {
                formContact.submit();
            }
        }

        return false;
  }

  const initCaptcha = () => {
    const container = document.querySelector('pre.captcha-digits');
    if (null != container) {
        container.innerHTML = generateCaptcha();
    }

    const contactFormButton = document.querySelector('#ContactForm button[type=submit]');
    if (null != contactFormButton) {
        contactFormButton.addEventListener('click', onSubmitHandler);
    }
  }

  initCaptcha();
})();
